import React from 'react';
import { ResponsiveContainer, AreaChart, Area, Tooltip } from 'recharts';

export function AcceptedInvitesSparkline({ trend }) {
  if (!trend?.length) return null;
  const total = trend.reduce((a, d) => a + d.accepted, 0);
  const today = trend[trend.length - 1]?.accepted ?? 0;
  return (
    <div className="flex items-center gap-3 ml-auto mr-2" data-testid="accepted-invites-sparkline">
      <div className="text-right leading-tight">
        <p className="text-white text-sm font-semibold" data-testid="accepted-invites-total">{total}</p>
        <p className="text-[10px] text-[#5C7599]">accepted · 14d ({today} today)</p>
      </div>
      <div className="w-28 h-9">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={trend} margin={{ top: 2, right: 0, left: 0, bottom: 0 }}>
            <Tooltip
              cursor={false}
              contentStyle={{ background: '#000B18', border: '1px solid #ffffff20', fontSize: 11, padding: '2px 6px' }}
              labelFormatter={(_, p) => p?.[0]?.payload?.date}
              formatter={(v) => [v, 'accepted']}
            />
            <Area type="monotone" dataKey="accepted" stroke="#00E676" strokeWidth={1.5} fill="#00E67626" isAnimationActive />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
